import { SOLUTIONS, solutionPath } from './solutions'
import { VC_PATH } from './dgpt'
import { BUILDER_PATH } from './customBuilder'

export type SolutionsMenuItem = {
  label: string
  descriptor: string
  href: string
  /** Nested link shown under the item (Invest → Venture Capital). */
  child?: { label: string; descriptor: string; href: string }
}

/** Solutions dropdown / accordion contents, shared by desktop and mobile. */
export const SOLUTIONS_MENU: SolutionsMenuItem[] = SOLUTIONS.map((solution) => ({
  label: solution.label,
  descriptor: solution.descriptor,
  href: solutionPath(solution.id),
  child: solution.id === 'invest' ? { label: 'Venture Capital', descriptor: 'Where we started', href: VC_PATH } : undefined,
}))

/** Featured item shown below the six workflows in the Solutions menu. */
export const BUILDER_MENU_ITEM = {
  label: 'Custom Workflow Builder',
  descriptor: 'Build your own diligence application with AI',
  href: BUILDER_PATH,
  badge: 'New',
}
